var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-spin",
    { attrs: { spinning: _vm.formOption.busy } },
    [
      _c(
        "a-form",
        {
          attrs: {
            form: _vm.form,
            "label-col": { span: 4 },
            "wrapper-col": { span: 12 },
          },
        },
        [
          _c(
            "a-form-item",
            { attrs: { label: "宣传册名称" } },
            [
              _c("a-input", {
                directives: [
                  {
                    name: "decorator",
                    rawName: "v-decorator",
                    value: ["brochureName", _vm.rules.brochureName],
                    expression: "['brochureName', rules.brochureName]",
                  },
                ],
                attrs: {
                  maxLength: 30,
                  placeholder: "请输入宣传册名称,最多不超过30个字",
                },
              }),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-form-item",
                { attrs: { label: "分类" } },
                [
                  _c("a-tree-select", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["brochureClassify", _vm.rules.brochureClassify],
                        expression:
                          "['brochureClassify',rules.brochureClassify]",
                      },
                    ],
                    attrs: {
                      "allow-clear": "",
                      "dropdown-style": {
                        maxHeight: "300px",
                        overflow: "auto",
                      },
                      placeholder: "请选择分类",
                      treeData: _vm.treeData,
                      replaceFields: {
                        children: "children",
                        title: "codeName",
                        key: "codeId",
                        value: "codeId",
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-col",
                [
                  _c(
                    "div",
                    {
                      staticStyle: {
                        color: "#ff0000",
                        "line-height": "30px",
                        "margin-left": "106px",
                      },
                    },
                    [
                      _vm._v(
                        "宣传册类型:（仅可选择一类宣传册类型，若切换则已填写内容会被清空）"
                      ),
                    ]
                  ),
                  _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "宣传册类型",
                        "label-col": { span: 4 },
                        "wrapper-col": { span: 20 },
                        required: true,
                      },
                    },
                    [
                      _c(
                        "a-radio-group",
                        {
                          attrs: { "button-style": "solid" },
                          on: {
                            change: function ($event) {
                              return _vm.toggleType(_vm.brochureType)
                            },
                          },
                          model: {
                            value: _vm.brochureType,
                            callback: function ($$v) {
                              _vm.brochureType = $$v
                            },
                            expression: "brochureType",
                          },
                        },
                        [
                          _c("a-radio-button", { attrs: { value: "image" } }, [
                            _vm._v("图片"),
                          ]),
                          _c("a-radio-button", { attrs: { value: "video" } }, [
                            _vm._v("视频"),
                          ]),
                          _c("a-radio-button", { attrs: { value: "file" } }, [
                            _vm._v("文件"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _vm.brochureType === "image"
                ? [
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "图片设置",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("uploader", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["imageUrls", _vm.rules.imageUrls],
                              expression: "['imageUrls',rules.imageUrls]",
                            },
                          ],
                          attrs: {
                            num: 9,
                            accept: ".jpg,.jpeg,.PNG,.JPG,.JPEG",
                            url: _vm.api.temp.UPLOAD_TALK,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f00",
                          "margin-left": "16.66666666666666666%",
                        },
                      },
                      [_vm._v("建议格式：.png,.jpg, 最大为10MB,最多不超过9张")]
                    ),
                  ]
                : _vm._e(),
              _vm.brochureType === "video"
                ? [
                    _c(
                      "a-form-item",
                      {
                        staticStyle: { "margin-top": "10px" },
                        attrs: {
                          label: "视频封面",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("uploader", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["coverImg"],
                              expression: "['coverImg']",
                            },
                          ],
                          ref: "videoCoverUploader",
                          attrs: {
                            num: 1,
                            accept: "image/*",
                            url: _vm.api.temp.UPLOAD_LIMIT,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "视频设置",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("uploader", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["videoUrls", _vm.rules.videoUrls],
                              expression: "['videoUrls',rules.videoUrls]",
                            },
                          ],
                          attrs: {
                            num: 1,
                            accept: ".mp4",
                            url: _vm.api.temp.UPLOAD_LIMIT,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f00",
                          "margin-left": "16.66666666666666666%",
                        },
                      },
                      [_vm._v("建议格式：.mp4，最大为10MB，最多1个")]
                    ),
                  ]
                : _vm._e(),
              _vm.brochureType === "file"
                ? [
                    _c(
                      "a-form-item",
                      {
                        staticStyle: { "margin-top": "10px" },
                        attrs: {
                          label: "文件封面",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("uploader", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["coverImg"],
                              expression: "['coverImg']",
                            },
                          ],
                          ref: "fileCoverUploader",
                          attrs: {
                            num: 1,
                            accept: "image/*",
                            url: _vm.api.temp.UPLOAD_LIMIT,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "文件设置",
                          "label-col": { span: 4 },
                          "wrapper-col": { span: 20 },
                        },
                      },
                      [
                        _c("uploader", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["fileUrls", _vm.rules.fileUrls],
                              expression: "['fileUrls',rules.fileUrls]",
                            },
                          ],
                          attrs: {
                            num: 1,
                            accept:
                              ".xlsx,.ppt,.doc,.pdf,.txt,.xls,.docx,.pptx",
                            url: _vm.api.temp.UPLOAD_LIMIT,
                          },
                        }),
                      ],
                      1
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          color: "#f00",
                          "margin-left": "16.66666666666666666%",
                        },
                      },
                      [
                        _vm._v(
                          "建议格式.xlsx,.ppt,.doc,.pdf,.txt,.xls,.docx,.pptx文件，最大为20MB，最多1个"
                        ),
                      ]
                    ),
                  ]
                : _vm._e(),
            ],
            2
          ),
          _c(
            "a-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "a-form-item",
                { attrs: { label: "是否全部成员可见", required: true } },
                [
                  _c("a-switch", {
                    on: { change: _vm.handleisVisibleChange },
                    model: {
                      value: _vm.isVisible,
                      callback: function ($$v) {
                        _vm.isVisible = $$v
                      },
                      expression: "isVisible",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          !_vm.isVisible
            ? _c(
                "a-row",
                { attrs: { gutter: 24 } },
                [
                  _c(
                    "a-form-item",
                    { attrs: { label: "可见权限" } },
                    [
                      _c("a-tree-select", {
                        directives: [
                          {
                            name: "decorator",
                            rawName: "v-decorator",
                            value: ["deptList"],
                            expression: "['deptList']",
                          },
                        ],
                        attrs: {
                          "allow-clear": "",
                          "show-search": "",
                          "tree-checkable": "",
                          "dropdown-style": {
                            maxHeight: "300px",
                            overflow: "auto",
                          },
                          "tree-data": _vm.deptTreeList,
                          "search-placeholder": "请选择可见权限的部门",
                          treeDefaultExpandAll: false,
                          filterTreeNode: _vm.filterTreeNodeOption,
                          treeDefaultExpandedKeys: _vm.defaultExpandedKeys,
                          replaceFields: {
                            children: "children",
                            title: "deptName",
                            key: "deptId",
                            value: "deptId",
                          },
                        },
                        on: {
                          "update:treeDefaultExpandedKeys": function ($event) {
                            _vm.defaultExpandedKeys = $event
                          },
                          "update:tree-default-expanded-keys": function (
                            $event
                          ) {
                            _vm.defaultExpandedKeys = $event
                          },
                          change: _vm.handleDeptTree,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "a-space",
        { staticClass: "a-form-btn-box" },
        [
          _c(
            "a-button",
            {
              on: {
                click: function ($event) {
                  return _vm.endEdit("cancelled")
                },
              },
            },
            [_vm._v("取消")]
          ),
          _c(
            "a-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function ($event) {
                  return _vm._save(false)
                },
              },
            },
            [_vm._v("提交")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }